import React, { useState, useEffect } from "react";
import AddPackages from "./AddPackages";
import { getPackages, getPackageById } from "../../apis/packages";
import { getRoomTypes } from "../../apis/room";
import CommonPagination from "../../components/CommanPagination";
import MastersBreadcrumb from "../../components/MastersBreadcrumb";

const PackagesList: React.FC = () => {
  const [packages, setPackages] = useState<any[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [editableId, setEditableId] = useState<number | null>(null);
  const [selectedPackage, setSelectedPackage] = useState<any>(null);
  const [roomTypes, setRoomTypes] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({ currentPage: 1, perPage: 10, total: 0 });

  useEffect(() => {
  fetchPackages({ page: 1, per_page: 10 });
  fetchRoomTypes();
}, []);

  const fetchPackages = async (params: any = { page: 1, per_page: 10 }) => {
    try {
      const res: any = await getPackages(params);
      setPackages(res.data || res);
      setMeta(res.meta);
    } catch (error) {
      console.log("Error fetching packages:", error);
    }
  };

  const fetchRoomTypes = async () => {
  try {
    const res: any = await getRoomTypes();
    setRoomTypes(res.data || res);
  } catch (error) {
    console.log(error);
    setRoomTypes([]);
  }
};
  const handleSuccess = () => {
    fetchPackages({ page: meta.currentPage, per_page: meta.perPage });
  };

  const handlePaginationChange = (page: number, pageSize?: number) => {
    fetchPackages({ page, per_page: pageSize || 10 });
  };
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <MastersBreadcrumb current="Packages" />
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Packages List
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            List of all packages.
          </p>
        </div>

        <button
          onClick={() => setOpenModal(true)}
          className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
        >
          Add Package
        </button>
      </div>

      <AddPackages
        open={openModal}
        editableId={editableId}
        width="max-w-4xl"  
        packageData={selectedPackage}
        onClose={() => {
          setOpenModal(false);
          setEditableId(null);
          setSelectedPackage(null);
        }}
        onSuccess={handleSuccess}
      />

      <div className="flow-root mt-8">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                  Name
                </th>
                <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                  Fee
                </th>
                <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {packages.length === 0 ? (
                <tr>
                  <td colSpan={3} className="py-4 text-center text-sm text-gray-500">
                    No packages found
                  </td>
                </tr>
              ) : (
                packages.map((pkg) => (
                  <tr key={pkg.id}>
                    <td className="py-4 px-3 text-sm font-medium text-gray-900">
                      {pkg.name}
                    </td>
                    <td className="py-4 px-3 text-sm text-gray-700">
                     <span className="text-gray-900">₹</span> {
                        pkg.totalFee ? pkg.totalFee.toFixed(2) : "-"
                      }
                    </td>
                    <td className="py-4 px-3">
                      <button
                        onClick={async () => {
                          const res: any = await getPackageById(pkg.id);
                          setEditableId(pkg.id);
                          setSelectedPackage(res.data || res);
                          setOpenModal(true);
                        }}
                        className="px-3 py-2 text-sm text-white bg-primary rounded"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <CommonPagination meta={meta} onChange={handlePaginationChange} />
      </div>
    </div>
  );
};

export default PackagesList;